module.exports = __webpack_public_path__ + "static/hcpopcorn-933d321cd43f6e15de2327c5fa43f91e.jpg";